import { render, staticRenderFns } from "./DataPackageSize.vue?vue&type=template&id=f724af3e&scoped=true&"
import script from "./DataPackageSize.vue?vue&type=script&lang=js&"
export * from "./DataPackageSize.vue?vue&type=script&lang=js&"
import style0 from "./DataPackageSize.vue?vue&type=style&index=0&id=f724af3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f724af3e",
  null
  
)

export default component.exports